import { defineAsyncComponent } from 'vue'

export default defineAsyncComponent(() => import('./sf-math-formula.vue'))
